import React, { useState } from 'react';
import './palette.scss';

const Palette = () => {
    const [copied, setCopied] = useState(null);

    const handleCopy = (hex) => {
        navigator.clipboard.writeText(hex)
            .then(() => {
                setCopied(hex);
                setTimeout(() => setCopied(null), 1500);
            })
            .catch(err => console.error('Failed to copy:', err));
    };

    const colors = [
        { class: 'yellow', name: 'LIME YELLOW', hex: '#E5FE00', stroke: 'black' },
        { class: 'purple', name: 'AMETHYST PURPLE', hex: '#8559E3', stroke: 'black' },
        { class: 'blue', name: 'COOL CYAN-BLUE', hex: '#12AAFF', stroke: 'black' },
        { class: 'green', name: 'MINT GREEN', hex: '#99FF80', stroke: 'black' },
        { class: 'orange', name: 'VIVID VERMILION', hex: '#FE5C32', stroke: 'black' },
        { class: 'silver', name: 'MIST SILVER', hex: '#DAD9D9', stroke: 'black' },
        { class: 'gray', name: 'GRAPHITE GRAY', hex: '#252525', stroke: '#DAD9D9' },
        { class: 'black', name: 'JET BLACK', hex: '#111111', stroke: '#DAD9D9' },
    ];

    return (
        <section className='palette_bg'>
            <div className="custom-container palette_main">
                <h3 className="brand_common_heading">Color Palette</h3>

                <div className="palette_grid">
                    {colors.map(({ class: colorClass, name, hex, stroke }) => (
                        <div key={hex} className={`palette_grid_child ${colorClass}`}>
                            <p className="color_p">{name}</p>
                            <div className="hex">
                                <p className="hex_p">{hex}</p>

                                <div
                                    className={`icon-wrapper ${copied === hex ? 'copied' : ''}`}
                                    onClick={() => handleCopy(hex)}
                                >
                                    {/* Copy icon */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        className="copy-icon"
                                    >
                                        <path
                                            d="M20 8H10C8.89543 8 8 8.89543 8 10V20C8 21.1046 8.89543 22 10 22H20C21.1046 22 22 21.1046 22 20V10C22 8.89543 21.1046 8 20 8Z"
                                            stroke={stroke}
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4"
                                            stroke={stroke}
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>

                                    {/* Tick icon */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        className="tick-icon"
                                    >
                                        <path
                                            d="M20 6L9 17L4 12"
                                            stroke={stroke}
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Palette;
